module.exports = __webpack_public_path__ + "img/avatar1.94003425.png";